export const localStoreKeys = {
    sectorSelectedOnDetail: "sectorSelectedOnDetailScreen",
    marketIntelInhouseApps: "marketIntelInhouseApps",
    isSideBarCollapsed: "isSideBarCollapsed",
    accessibleUserSectors: "accessibleUserSectors",
    accessibleUserSectorsFromModal: "accessibleUserSectorsFromModal",
    feedbackFormUrl: "feedbackFormUrl",
    maxDateForApps: "maxDateForApps",
    fromDateDisplayValue: "fromDateDisplayValue",
    isSpmModalOpened: "isSpmModalOpened",
    isResilincModalOpened: "isResilincModalOpened",
    isNPSSubmittedRecently:"isNPSSubmittedRecently",
    userDefaultRole:"userDefaultRole",
    userEmailID:'userEmailID',
    userData: 'userData', // Unified auth user data
    oktaUserData: 'oktaUserData', // Kept for backward compatibility
    newsArticleBookmarkCount: "newsArticleBookmarkCount",
    maxAllowedBookmarks: "maxAllowedBookmarks",
    isStartTour: "isStartTour",
    commodityL1SwitcherIndex: "commodityL1SwitcherIndex",
    commodityL1RestoreSwitcher: "commodityL1RestoreSwitcher"
}
